import { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../atoms';
import { FormField, PhoneInput, UserTypeSelect } from '../../molecules';

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  margin: 0 0 24px;
  font-size: 24px;
  color: #333;
  text-align: center;
`;

const RegisterForm = ({ onSubmit, disabled = false }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    passwordConfirm: '',
    name: '',
    phone: '',
    type: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      [field]: e.target.value
    });
    // 입력 시 해당 필드의 에러 제거
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: ''
      });
    }
  };

  const handlePhoneChange = (value) => {
    setFormData({
      ...formData,
      phone: value
    });
    // 입력 시 해당 필드의 에러 제거
    if (errors.phone) {
      setErrors({
        ...errors,
        phone: ''
      });
    }
  };

  const handleTypeChange = (value) => {
    setFormData({
      ...formData,
      type: value
    });
    // 입력 시 해당 필드의 에러 제거
    if (errors.type) {
      setErrors({
        ...errors,
        type: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = '이메일을 입력해주세요';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = '유효한 이메일 주소를 입력해주세요';
    }

    if (!formData.password) {
      newErrors.password = '비밀번호를 입력해주세요';
    } else if (formData.password.length < 6) {
      newErrors.password = '비밀번호는 최소 6자 이상이어야 합니다';
    }

    if (!formData.passwordConfirm) {
      newErrors.passwordConfirm = '비밀번호 확인을 입력해주세요';
    } else if (formData.password !== formData.passwordConfirm) {
      newErrors.passwordConfirm = '비밀번호가 일치하지 않습니다';
    }

    if (!formData.name) {
      newErrors.name = '이름을 입력해주세요';
    }

    if (!formData.phone) {
      newErrors.phone = '전화번호를 입력해주세요';
    } else if (!/^010-\d{4}-\d{4}$/.test(formData.phone)) {
      newErrors.phone = '전화번호를 모두 입력해주세요';
    }

    if (!formData.type) {
      newErrors.type = '사용자 유형을 선택해주세요';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSubmit(formData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Title>회원가입</Title>

      <FormField
        label="이메일"
        type="email"
        placeholder="이메일을 입력하세요"
        value={formData.email}
        onChange={handleChange('email')}
        error={errors.email}
        disabled={disabled}
      />

      <FormField
        label="비밀번호"
        type="password"
        placeholder="비밀번호를 입력하세요 (최소 6자)"
        value={formData.password}
        onChange={handleChange('password')}
        error={errors.password}
        disabled={disabled}
      />

      <FormField
        label="비밀번호 확인"
        type="password"
        placeholder="비밀번호를 다시 입력하세요"
        value={formData.passwordConfirm}
        onChange={handleChange('passwordConfirm')}
        error={errors.passwordConfirm}
        disabled={disabled}
      />

      <FormField
        label="이름"
        type="text"
        placeholder="이름을 입력하세요"
        value={formData.name}
        onChange={handleChange('name')}
        error={errors.name}
        disabled={disabled}
      />

      <PhoneInput
        label="전화번호"
        value={formData.phone}
        onChange={handlePhoneChange}
        error={errors.phone}
        disabled={disabled}
      />

      <UserTypeSelect
        label="사용자 유형"
        value={formData.type}
        onChange={handleTypeChange}
        error={errors.type}
        disabled={disabled}
      />

      <Button type="submit" style={{ width: '100%' }} disabled={disabled}>
        {disabled ? '회원가입 중...' : '회원가입'}
      </Button>
    </Form>
  );
};

export default RegisterForm;
